/* eslint-disable max-len */
import React from 'react'
import formatMobileNumber from '../../../../CommonMethods/FormatMobileNumber'
import OtpPreferenceList from '../../../../components/OtpPreferenceList'


export default function ViewPatientDetails({ patientDetails, date }) {
    return (
        <div className=" p-1.5 mt-[26px] border border-[#E7CBD2] rounded-lg mx-[28px]">
            <div className="w-full px-4 py-6 xl:h-[calc(100vh-395px)] h-[calc(100vh-416px)] overflow-auto scrollbar_grayw6 ">
                <section>
                    <div className='flex items-center mb-3.5'>
                        <h1 className='text-lg font-normal text-[#000000] min-w-max'>Basic Details</h1>
                        <div className='relative w-full h-[1px] bg-[#008586] ml-3 down-arraow'></div>
                    </div>
                    <div className="flex -mx-1 flex-wrap">
                        <div className="w-full px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Username</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.user_name}</p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Email Address</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.email_address !== "" ? patientDetails?.email_address : '-'}</p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.mobile_number !== "" ? patientDetails.country_code2 + "\t" + formatMobileNumber(patientDetails?.mobile_number) : "-"}</p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Main Number</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails.country_code1} {formatMobileNumber(patientDetails.main_number)}</p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Date of Birth</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.date_of_birth !== "" ? patientDetails?.date_of_birth : '-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Age</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.age !== "" ? patientDetails?.age : '-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Gender</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.gender !== "" ? patientDetails?.gender : '-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-full px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Address</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails.address !== "" ? patientDetails.address : '-'}</p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Primary Identifier</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.primary_identifier !== "" ? patientDetails?.primary_identifier : '-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Secondary Identifier</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.secondary_identifier !== "" ? patientDetails?.secondary_identifier : '-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Onboarding Date</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.onboarding_date !== "" ? patientDetails?.onboarding_date : '-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="flex -mx-1">
                                <div className="w-1/2 px-1">
                                    <div className="w-full">
                                        <p className="text-sm font-normal text-[#000]">Weight(kg)</p>
                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                            {patientDetails?.weight_kgs !== "" ? patientDetails?.weight_kgs : '-'}
                                        </p>
                                    </div>
                                </div>
                                <div className="w-1/2 px-1">
                                    <div className="w-full">
                                        <p className="text-sm font-normal text-[#000]">Weight(lbs)</p>
                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                            {patientDetails?.weight_lbs !== "" ? patientDetails?.weight_lbs : '-'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="w-1/3 px-1 mb-6">
                            <div className="flex -mx-1">
                                <div className="w-1/2 px-1">
                                    <div className="w-full">
                                        <p className="text-sm font-normal text-[#000]">Height(inch)</p>
                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                            {patientDetails?.height_inch !== "" ? patientDetails?.height_inch : '-'}
                                        </p>
                                    </div>
                                </div>
                                <div className="w-1/2 px-1">
                                    <div className="w-full">
                                        <p className="text-sm font-normal text-[#000]">Height(cm)</p>
                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                            {patientDetails?.height_cm !== "" ? patientDetails?.height_cm : '-'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Patient Status</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.patient_status !== "" ? patientDetails?.patient_status : '-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Timezone</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.timezone_with_offset}: ({patientDetails?.abbreviation}) {patientDetails?.utcoffset} 
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Monitoring Status</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.monitoring_status !== "" ? patientDetails?.monitoring_status : '-'}
                                </p>
                            </div>
                        </div>
                       

                        {/* <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Monitoring Cycle Start Date</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.monitoring_cycle_date!==""?patientDetails?.monitoring_cycle_date:'-'}
                                </p>
                            </div>
                        </div> */}
                    </div>
                </section>
                {/* otp preference screeen */}
                {patientDetails?.user_name && 
                    <OtpPreferenceList
                        username={patientDetails?.user_name}
                        user_type={'patient-user'}
                    />
                }
                <section>
                    <div className='flex items-center mb-3.5 mt-1'>
                        <h1 className='text-lg font-normal text-[#000000] min-w-max'>Minimum Readings Conditions (By Default {patientDetails?.defaultReadings?.number_of_readings !== null ? patientDetails?.defaultReadings?.number_of_readings : '0'} Readings In {patientDetails?.defaultReadings?.number_of_time_periods !== null ? patientDetails?.defaultReadings?.number_of_time_periods : '0'} {patientDetails?.defaultReadings?.time_period}  )</h1>
                        <div className='relative w-full h-[1px] bg-[#008586]  ml-3 down-arraow'></div>
                    </div>
                    <div className="flex bg-[#E5F3F3] border border-transparent rounded-[4px] py-3 px-2.5 -mx-[7px] flex-wrap mb-[20px]">
                        <div className="ml-[40px]">
                            <p className="text-sm font-normal text-[#000]">Readings</p>
                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                {patientDetails?.number_of_readings}</p>
                        </div>
                        <div className="mx-[40px]">
                            <p className="text-sm font-normal text-[#000]">Number of Days</p>
                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                {patientDetails?.number_of_time_periods}</p>
                        </div>
                        <div className="">
                            <p className="text-sm font-normal text-[#000]">Time Period</p>
                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                {patientDetails?.time_period}</p>
                        </div>




                    </div>
                </section>
                {(patientDetails?.contacts?.length > 0 || patientDetails?.case_managers?.length > 0) &&
                    <section>
                        <div className='flex items-center mb-3.5 mt-1'>
                            <h1 className='text-lg font-normal text-[#000000] min-w-max'>Additional Contact Details</h1>
                            <div className='relative w-full h-[1px] bg-[#008586] ml-3 down-arraow'></div>
                        </div>
                        <div className="flex -mx-[7px] flex-wrap">

                            {patientDetails?.contacts?.length > 0 &&
                                <div className="w-1/2 px-[7px] mb-6">
                                    <div className="w-full border border-[#CCE7E7] rounded-[4px] bg-[#E5F3F3] pt-5 px-2.5">
                                        <h1 className='text-lg font-normal text-[#000000] w-full pb-3 border-b-[2px] border-[#972E4C]'>Emergency Contact Details (First entry is highest priority)</h1>
                                        <div className='px-2.5'>
                                            {patientDetails.contacts?.map((contact, index) => (
                                                <div key={index} className={`flex -mx-2.5 py-6 ${index !== 0 ? 'border-t-[4px] border-[#CCE7E7]' : ''}`}>
                                                    <div className='w-1/2 pl-2.5 pr-1'>
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Name</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {contact.name !== "" ? contact.name : '-'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className='w-1/2 pl-2.5 pr-1'>
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {contact.contact_number !== "" ?
                                                                    contact.country_code + "\t" + formatMobileNumber(contact.contact_number) :
                                                                    "-"}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            }

                            {patientDetails?.case_managers?.length > 0 &&
                                <div className="w-1/2 px-[7px] mb-6">
                                    <div className="w-full border border-[#CCE7E7] rounded-[4px] bg-[#E5F3F3] pt-5 px-2.5">
                                        <h1 className='text-lg font-normal text-[#000000] w-full pb-3 border-b-[2px] border-[#972E4C]'>Case Manager Contact Details (First entry is highest priority) </h1>
                                        <div className='px-2.5'>
                                            {patientDetails?.case_managers?.map((caseManager, index) => (
                                                <div key={index} className={`flex -mx-2.5 py-6 ${index !== 0 ? 'border-t-[4px] border-[#CCE7E7]' : ''}`}>
                                                    <div className='w-1/2 pl-2.5 pr-1'>
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Name</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {caseManager.name !== "" ? caseManager.name : '-'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className='w-1/2 pl-2.5 pr-1'>
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {caseManager.contact_number !== "" ?
                                                                    caseManager.country_code + "\t" + formatMobileNumber(caseManager.contact_number) :
                                                                    "-"}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}

                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </section>
                }
                <section>
                    <div className='flex items-center mb-3.5 mt-1'>
                        <h1 className='text-lg font-normal text-[#000000] min-w-max'>Organizational Assignment and User Associations</h1>
                        <div className='relative w-full h-[1px] bg-[#008586] ml-3 down-arraow'></div>
                    </div>
                    <div className="w-full px-1 mb-6 flex">
                        <div className="w-1/2">
                            <p className="text-sm font-normal text-[#000]">Organization Name</p>
                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                {patientDetails?.organization_name}</p>
                        </div>
                        <div className="w-1/2">
                            <p className="text-sm font-normal text-[#000]">Sub Division Name</p>
                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                {patientDetails?.subdivision_name}</p>
                        </div>
                    </div>

                </section>
            </div>
        </div>
    )
}
